class VideoAutoplayC extends HTMLElement {
    constructor() {
        super();

        this.videoElement = null;
        this.intersectionObserver = null;
    }

    connectedCallback() {
        this.videoElement = this.querySelector('video');
        if (this.videoElement) {
            this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), { threshold: 0 });
            this.intersectionObserver.observe(this.videoElement);
        }
    }

    disconnectedCallback() {
        if (this.intersectionObserver) {
            this.intersectionObserver.unobserve(this.videoElement);
            this.intersectionObserver = null;
        }
    }
    handleIntersection(entries) {
        const isVisible = entries[0].isIntersecting;
        const shouldAutoplay = this.videoElement.hasAttribute('autoplay');
        if (isVisible && shouldAutoplay) {
            this.playVideo();
        } else if (!isVisible) {
            this.pauseVideo();
        }
    }

    playVideo() {
        if (!this.videoElement) return;
        // Browsers only allow autoplay when the video is muted
        this.videoElement.muted = true;
        this.videoElement.play()
            .then(() => {
                this.classList.add('playing');
                this.classList.remove('paused');
            })
            .catch(() => {
                // Autoplay was blocked (e.g. user preference or not muted)
            });
    }

    pauseVideo() {
        if (this.videoElement) {
            this.videoElement.pause();
            this.classList.add('paused');
            this.classList.remove('playing');
        }
    }
}


if (!window.customElements.get('video-autoplay-c')) {
    customElements.define('video-autoplay-c', VideoAutoplayC);
}
